export default ".metric-label{display:block;width:140px;min-width:140px;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}";